import {
  EventProps,
  PageEvents,
  SuperProperties,
  UserProperties,
  WebPageEvents,
  WebTrackingEvent,
} from '@griply/types';
import mixpanel from 'mixpanel-browser';
import { ID } from 'shared/types/id';

const pageEvents: string[] = [
  ...Object.values(PageEvents),
  ...Object.values(WebPageEvents),
];

export class MixpanelService {
  private static instance: typeof mixpanel;

  get mixpanel(): typeof mixpanel {
    if (!MixpanelService.instance) {
      MixpanelService.instance = mixpanel;
    }

    return MixpanelService.instance;
  }

  constructor(superProperties?: SuperProperties) {
    if (!MixpanelService.instance) {
      this.mixpanel.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {
        api_host: 'https://api-eu.mixpanel.com',
        debug: import.meta.env.MODE === 'development',
      });
    }

    superProperties && this.mixpanel.register(superProperties);
  }

  identifyUser(userId: ID): void {
    this.mixpanel.identify(userId);
  }

  setUserProperties(properties: Partial<UserProperties>): void {
    this.mixpanel.people.set(properties);
  }

  reset(): void {
    this.mixpanel.reset();
  }

  track<TrackEvent extends WebTrackingEvent>(
    trackEvent: TrackEvent,
    eventInfo?: EventProps<TrackEvent>,
  ): void {
    if (pageEvents.includes(trackEvent)) {
      this.mixpanel.track('screen_view', {
        screen: trackEvent,
        ...(eventInfo ?? {}),
      });

      return;
    }

    this.mixpanel.track(trackEvent, eventInfo);
  }
}
